module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "panel-size-btn",
    class: {
      'panel-size-btn--expanded': _vm.isExpandedView
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 7,
      "height": 11
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.buttonText))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4acac5b2","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/attributePanel/PanelSizeBtn.vue
// module id = 2067
// module chunks = 0